<template>
	<div>
		<div style="width: 70%;margin-left: 15%;margin-top:30px;">
			<div style="text-align: center;">
				<div style="margin-top: 30px;margin-bottom: 50px;text-align: center;">
					<el-link @click="goBack" type="primary"><i class="el-icon-back"></i>返回上页</el-link>
				</div>
				<div style="margin-top: 30px;margin-bottom: 30px;font-size: 18px;font-weight: bold;">
					{{productDetail.title}}
				</div>
				<div style="width:70%;margin-left:15%;text-align: left;" class="vHtml" v-html="productDetail.detail"></div>
			</div>
			<div v-if="productDetail.ifHiddenImg != true" v-for="item in productDetail.url" style="text-align: center;display: inline-block;width:50%;margin-top: 20px;margin-bottom: 20px;vertical-align: top;">
				<el-image
				      style="width: 90%; height: auto;border:4px solid #EBEEF5;"
				      :src="item"
				      fit="contain">
					  <div slot="placeholder" style="text-align:center;padding-top:30%;font-size:12px;color:#909399;">
						加载中...
					  </div>
				</el-image>
				
			</div>
			
		</div>
	</div>
</template>

<script>
	import utils from '@/utils';
	export default {
		name: 'ProductDetail',
		data() {
			return {
				url:utils.fileUrl(),
				productDetail:{},
				productList:[
					
					
				],
				
			}
		},
		computed: {

		},
		components: {
			
		},
		methods: {
			goBack(){
				this.$router.go(-1);
			},
		},
		watch:{
		    '$route'(val, from) {
				console.log(val.query.id)
				for(let i=0;i<this.$store.state.product.length;i++){
					if(this.$store.state.product[i].id == val.query.id){
						this.productDetail = this.$store.state.product[i];
					}
				}
		    }
		  },
		mounted() {
			
			if(this.$route.query.id != undefined){
				for(let i=0;i<this.$store.state.product.length;i++){
					if(this.$store.state.product[i].id == this.$route.query.id){
						this.productDetail = this.$store.state.product[i];
					}
				}
			}
		}

	}
</script>

<style>
	.vHtml div:{
		margin-bottom: 10px;
		font-weight: bold;
	},
	.vHtml .marginDetail:{
		margin-bottom: 15px;
	}
</style>